if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          console.warn('[ProductForm] Abgebrochen: Button bereits deaktiviert.');
          return;
        }

        const variantIdInput = this.form.querySelector('[name="id"]');
        const variantId = variantIdInput?.value;

        if (!variantId) {
          console.error('[ProductForm] Fehler: Variant-ID nicht gefunden!');
          alert('Bitte wählen Sie eine Variante aus.');
          return;
        }

        console.log(`[ProductForm] Sende Produkt mit Variant-ID: ${variantId}`);

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          if (typeof this.cart.getSectionsToRender === 'function') {
            const sections = this.cart.getSectionsToRender();
            formData.append('sections', sections.map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
          } else {
            console.warn('[ProductForm] cart.getSectionsToRender() ist nicht verfügbar.');
          }

          if (typeof this.cart.setActiveElement === 'function') {
            this.cart.setActiveElement(document.activeElement);
          }
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            console.log(`[ProductForm] Serverstatus: ${response.status}`);
            return response.json();
          })
          .then((response) => {
            if (response.status) {
              console.error('[ProductForm] Fehlerhafte Antwort:', response);
              this.handleErrorMessage(response.description || response.message);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (soldOutMessage) {
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span')?.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }

              this.error = true;
              return;
            }

            console.log('[ProductForm] Erfolgreich zum Warenkorb hinzugefügt:', response);

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (typeof this.cart.renderContents === 'function') {
                      this.cart.renderContents(response);
                    } else {
                      console.warn('[ProductForm] cart.renderContents() nicht verfügbar – evtl. cart-notification?');
                      window.location = window.routes.cart_url;
                    }
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (typeof this.cart.renderContents === 'function') {
                this.cart.renderContents(response);
              } else {
                console.warn('[ProductForm] cart.renderContents() nicht verfügbar – evtl. cart-notification?');
                window.location = window.routes.cart_url;
              }
            }
          })
          .catch((error) => {
            console.error('[ProductForm] Netzwerk- oder JS-Fehler:', error);
            alert('Fehler beim Hinzufügen zum Warenkorb. Bitte versuchen Sie es erneut.');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart?.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }
            this.querySelector('.loading__spinner')?.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          console.warn('[ProductForm] Fehlermeldung angezeigt:', errorMessage);
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
